export type WalletProAccessOptionContract = {
  mode?: string;
  supportMode?: string;
  providers?: string[];
  regions?: string[];
  clusterTypes?: string[];
  requiredParameters?: string[];
  resolvedParameters?: Record<string, unknown>;
};

export type WalletProAccessLaunchContract = {
  mode: string;
  cluster_type?: string;
  support_mode?: string;
  providers?: string[];
  regions?: string[];
  cluster_types?: string[];
  required_parameters: string[];
  resolved_parameters: Record<string, string>;
};

function cleanString(value: unknown) {
  return String(value ?? "").trim();
}

function cleanStringList(values: unknown) {
  if (!Array.isArray(values)) return [];
  return Array.from(new Set(values.map(cleanString).filter(Boolean)));
}

function cleanResolvedParameters(values: unknown) {
  if (!values || typeof values !== "object" || Array.isArray(values)) return {};
  return Object.fromEntries(
    Object.entries(values)
      .map(([key, value]) => [cleanString(key), cleanString(value)])
      .filter(([key, value]) => key && value),
  );
}

export function walletProAccessLaunchContract(input: {
  mode?: string;
  clusterType?: string;
  option?: WalletProAccessOptionContract | null;
}): WalletProAccessLaunchContract | undefined {
  const mode = cleanString(input.mode).toLowerCase();
  if (!mode) return undefined;

  const option = input.option || {};
  const resolved = cleanResolvedParameters(option.resolvedParameters);
  const required = cleanStringList(option.requiredParameters);

  return {
    mode,
    cluster_type: cleanString(input.clusterType) || undefined,
    support_mode: cleanString(option.supportMode) || undefined,
    providers: cleanStringList(option.providers),
    regions: cleanStringList(option.regions),
    cluster_types: cleanStringList(option.clusterTypes),
    required_parameters: required,
    resolved_parameters: resolved,
  };
}

export function walletProAccessMissingRequiredParameters(
  contract?: WalletProAccessLaunchContract,
) {
  if (!contract) return [];
  return contract.required_parameters.filter((key) => !contract.resolved_parameters[key]);
}
